import React from "react";
import Modal from "../modal/Modal";
import m from "./Progress.module.scss";
interface M {
  openModal: Boolean;
}
/*****************************
 * Progress Bar
 ****************************/
export default function ProgressBar({ openModal }: M) {
  // console.log(openModal);

  return (
    <>
      <Modal openModal={openModal}>
        <div className={m.progress_container}>
          <h5>Subiendo archivo....</h5>

          <progress id="progress-bar" />
        </div>
      </Modal>
    </>
  );
}
